import { z } from "zod";
import { sloObjectiveSchema, uuidSchema } from "./common";

const sloQueryPattern = /^[a-z_]+\([^()]*\)$/;

/** `POST /v1/slos` body. Mirrors `CreateSlo` in routes_ops.rs (target 50-100, matching the server clamp). */
export const createSloSchema = z.object({
  asset_id: uuidSchema,
  name: z.string().trim().min(1, "name is required").max(200),
  objective_type: sloObjectiveSchema,
  target_percentage: z.coerce.number().min(50, "must be between 50 and 100").max(100),
  window_days: z.coerce.number().int().min(1).max(365).optional(),
  good_event_query: z
    .string()
    .trim()
    .min(1, "required, e.g. check_passing(<check-id>)")
    .regex(sloQueryPattern, "must look like a function call, e.g. check_passing(<check-id>)"),
  total_event_query: z
    .string()
    .trim()
    .min(1, "required, e.g. check_total(<check-id>)")
    .regex(sloQueryPattern, "must look like a function call, e.g. check_total(<check-id>)"),
  burn_rate_alerts: z
    .array(z.object({ factor: z.coerce.number().min(0), window_hours: z.coerce.number().int().min(0) }))
    .default([]),
});
export type CreateSloInput = z.infer<typeof createSloSchema>;
